<template>
  <div>
    <HeaderBackButton title="Click & Collect" />
    <base-flex-spinner v-if="isLoading" />
    <div
      v-else
      class="mx-6"
    >
      <information-panel class="p-6 mx-0">
        <div class="flex flex-row gap-6">
          <div class="flex flex-col items-start">
            <h2 class="text-white">
              Gérez les commandes facilement
            </h2>
            <p class="text-neutral">
              Équipez vos patients de l'app Apodis pour qu'ils accèdent à votrevitrine, vos promotions, et passent
              commande en 2 clics.
            </p>
          </div>
          <Dialog v-model:open="showVideoModal">
            <DialogTrigger>
              <img class="w-52 cursor-pointer" alt="tutoriel" src="@/assets/images/thumbnail_video_default.png">
            </DialogTrigger>
            <DialogContent class="min-w-[90%] max-h-auto">
              <DialogTitle>Gestion d'une commande Click & Collect</DialogTitle>
              <embed-video class="w-full" url="https://www.youtube.com/embed/DmP2f4GxNaI" />
            </DialogContent>
          </Dialog>
        </div>
      </information-panel>

      <div class="space-y-4">
        <OrderIndexRow
          v-for="order in data"
          :key="order.id"
          class="cursor-pointer"
          :order="order"
          show-customer-name
          @click="selectedOrderId = order.id"
        />
      </div>
      <div class="text-center mb-4">
        <v-pagination
          v-model="page"
          :length="meta.last_page"
          :total-visible="7"
          circle
        />
      </div>
      <action-modal
        v-if="selectedOrderId"
        :order-id="selectedOrderId"
        :opened="!!selectedOrderId"
        @close-modal="closeModal"
        @show="show"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import {ref} from "vue";
import useOrders from "@/order/composables/useOrders";
import {useRouter} from "vue-router";
import HeaderBackButton from "@/core/components/header-back-button/HeaderBackButton.vue";
import BaseFlexSpinner from "@/core/components/base/spinner/BaseFlexSpinner.vue";
import InformationPanel from "@/core/components/information-panel/InformationPanel.vue";
import {Dialog, DialogTrigger, DialogContent, DialogTitle} from "@/core/components/ui/dialog";
import EmbedVideo from "@/core/components/video/EmbedVideo.vue";
import ActionModal from "@/order/components/OrderActionModal.vue";
import OrderIndexRow from "@/order/components/OrderIndexRow.vue";

const page = ref(1);
const router = useRouter();
const {data, meta, isLoading, mutate} = useOrders({
    page: page,
    limit: 10
});

const showVideoModal = ref(false);
const selectedOrderId = ref<number | null>(null);

/**
 * Redirect to the customer home page.
 *
 * @param customerId
 */
const show = (customerId: number) => {
    router.push({
        name: 'customer.home',
        params: {customerId}
    });
};

const closeModal = () => {
    selectedOrderId.value = null;
    mutate();
};
</script>
